<template>

    <div v-if="false" class="co-convidar-por-sms">
        <div class="checkbox-convidar-por-sms" :style="getStyleCheckbox" @click="alterarValue">

            <input :disabled="desabilitar" v-model="value.enviarConviteSMS"
                   :style="getStyleCheckbox" name="convidarSMS" type="checkbox">

            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <span v-on="on" class="checkbox-texto">Convidar por SMS</span>
                </template>
                <span v-if="!smsHabilitado" top>É necessário contratar o serviço de SMS, entre <br/> em contato com o suporte pelo chat</span>
                <span v-else> Restam: {{ saldoSms }}</span>
            </v-tooltip>

        </div>

        <div class="hint-checkbox">
            {{ descricaoCampo }}
        </div>

        <label-adquirir-saldo v-if="smsHabilitado" :saldo="saldoSms" exibir @adquirir-saldo="abrirLoja"/>

        <contratar-servico v-else @abrir-dialog-contratar-servico="abrirDialogContratarServico"/>
    </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import LabelAdquirirSaldo
    from '@/views/visualizar-contrato/barra-lateral/assinaturas/components/adicionar-signatario/components/campos-formulario/LabelAdquirirSaldo'
import ContratarServico
    from '@/views/visualizar-contrato/barra-lateral/assinaturas/components/adicionar-signatario/components/campos-formulario/ContratarServico'

export default {
    name: 'ConvidarPorSms',
    components: {
        ContratarServico,
        LabelAdquirirSaldo
    },
    props: {
        value: {
            required: true
        },
        desabilitarCampo: {
            type: Boolean
        }
    },
    watch: {
        'value.enviarConviteSMS': function alterandoValorStateSms() {
            if (this.value.enviarConviteSMS) {
                this.consumoOrganizacao.smsUtilizados += 1
            } else {
                this.consumoOrganizacao.smsUtilizados -= 1
            }
        }
    },
    computed: {
        ...mapState(['login', 'consumoOrganizacao']),
        ...mapGetters(['saldoSms']),
        desabilitar() {
            return (!this.possuiSMS && !this.checkBoxMarcado) || (this.desabilitarCampo && this.ehSignatarioConvidado)
        },
        descricaoCampo() {
            return `O sistema irá enviar uma mensagem ao telefone cadastrado para o ${this.$tc("pt_br.signatario").toLowerCase()} informando que no e-mail dele existe um convite de assinatura do documento.`
        },
        checkBoxMarcado() {
            return this.value.enviarConviteSMS
        },
        ehSignatarioConvidado() {
            return this.value.statusSignatario === 'CONVIDADO'
        },
        possuiSMS() {
            return this.smsHabilitado && this.saldoDisponivel
        },
        smsHabilitado() {
            return this.login.funcionalidadesOrganizacao.notificarConviteSMS
        },
        getStyleCheckbox() {
            return !this.desabilitar ? 'cursor: pointer' : 'cursor: not-allowed;'
        },
        saldoDisponivel() {
            return this.saldoSms > 0
        }
    },
    methods: {
        abrirLoja() {
            this.$router.push({name: 'planos'})
        },
        abrirDialogContratarServico() {
            this.$emit('abrir-dialog-contratar-servico')
        },
        alterarValue() {
            if (!this.desabilitar)
                this.value.enviarConviteSMS = !this.value.enviarConviteSMS
        }
    }
}
</script>

<style lang="stylus">
.co-convidar-por-sms
    .checkbox-convidar-por-sms
        display flex
        align-items center

        .checkbox-texto
            font-size 14px
            display flex
            margin-left 10px
            color #777777
            text-align right
</style>